/**
 * Thread tags (community_thread_tags_beta).
 * Each row links a thread to a single tag; a thread's `tags` array is derived from these.
 */
export const SEED_TAGS = [
  { thread_id: 1, tag: 'coffee' },
  { thread_id: 1, tag: 'morning' },
  { thread_id: 1, tag: 'seoul' },
  { thread_id: 2, tag: 'river' },
  { thread_id: 2, tag: 'sunset' },
  { thread_id: 2, tag: 'korea' },
  { thread_id: 3, tag: 'nightlife' },
  { thread_id: 3, tag: 'music' },
  { thread_id: 4, tag: 'tokyo' },
  { thread_id: 4, tag: 'travel' },
  { thread_id: 4, tag: 'crowd' },
  { thread_id: 5, tag: 'nyc' },
  { thread_id: 5, tag: 'usa' },
  { thread_id: 6, tag: 'nyc' },
  { thread_id: 6, tag: 'park' },
  { thread_id: 7, tag: 'transit' },
  { thread_id: 7, tag: 'seoul' },
  { thread_id: 11, tag: 'beach' },
  { thread_id: 11, tag: 'busan' },
  { thread_id: 12, tag: 'hiking' },
  { thread_id: 12, tag: 'jeju' },
  { thread_id: 8, tag: 'feedback' },
  { thread_id: 8, tag: 'darkmode' },
  { thread_id: 9, tag: 'welcome' },
  { thread_id: 10, tag: 'bug' },
  { thread_id: 10, tag: 'map' },
  { thread_id: 13, tag: 'london' },
  { thread_id: 13, tag: 'pub' },
  { thread_id: 13, tag: 'uk' },
  { thread_id: 14, tag: 'paris' },
  { thread_id: 14, tag: 'food' },
  { thread_id: 14, tag: 'france' },
  { thread_id: 15, tag: 'berlin' },
  { thread_id: 15, tag: 'tech' },
  { thread_id: 15, tag: 'startup' },
  { thread_id: 16, tag: 'rome' },
  { thread_id: 16, tag: 'history' },
  { thread_id: 16, tag: 'culture' },
  { thread_id: 17, tag: 'dubai' },
  { thread_id: 17, tag: 'marina' },
  { thread_id: 17, tag: 'luxury' },
  { thread_id: 18, tag: 'singapore' },
  { thread_id: 18, tag: 'streetfood' },
  { thread_id: 18, tag: 'hawker' },
  { thread_id: 19, tag: 'sydney' },
  { thread_id: 19, tag: 'harbour' },
  { thread_id: 19, tag: 'australia' },
  { thread_id: 20, tag: 'saopaulo' },
  { thread_id: 20, tag: 'art' },
  { thread_id: 20, tag: 'brazil' },
  { thread_id: 21, tag: 'mexicocity' },
  { thread_id: 21, tag: 'tacos' },
  { thread_id: 21, tag: 'streetfood' },
  { thread_id: 22, tag: 'toronto' },
  { thread_id: 22, tag: 'cycling' },
  { thread_id: 22, tag: 'canada' },
  { thread_id: 23, tag: 'losangeles' },
  { thread_id: 23, tag: 'beach' },
  { thread_id: 23, tag: 'sports' },
  { thread_id: 24, tag: 'cairo' },
  { thread_id: 24, tag: 'bazaar' },
  { thread_id: 24, tag: 'market' },
  { thread_id: 25, tag: 'capetown' },
  { thread_id: 25, tag: 'hiking' },
  { thread_id: 25, tag: 'africa' },
  { thread_id: 26, tag: 'istanbul' },
  { thread_id: 26, tag: 'ferry' },
  { thread_id: 26, tag: 'sunset' },
  { thread_id: 27, tag: 'bangkok' },
  { thread_id: 27, tag: 'night_market' },
  { thread_id: 27, tag: 'food' },
  { thread_id: 28, tag: 'hongkong' },
  { thread_id: 28, tag: 'skyline' },
  { thread_id: 28, tag: 'photography' },
  { thread_id: 29, tag: 'barcelona' },
  { thread_id: 29, tag: 'tapas' },
  { thread_id: 29, tag: 'spain' },
  { thread_id: 30, tag: 'amsterdam' },
  { thread_id: 30, tag: 'cycling' },
  { thread_id: 30, tag: 'canals' },
  { thread_id: 31, tag: 'mumbai' },
  { thread_id: 31, tag: 'chaat' },
  { thread_id: 31, tag: 'india' },
  { thread_id: 32, tag: 'melbourne' },
  { thread_id: 32, tag: 'coffee' },
  { thread_id: 32, tag: 'australia' },
];
